module.exports = {"closeButtonText":"Cerrar","thumbNailAlt":"Vista previa de la imagen","next":"Página siguiente","previous":"Página anterior","addNote":"Añadir una nota..."}


//////////////////
// WEBPACK FOOTER
// ./translations/es-ES.json
// module id = 31
// module chunks = 0